import { render } from "./Production.vue?vue&type=template&id=69d613fb&scoped=true&ts=true&lang=pug"
import script from "./Production.vue?vue&type=script&lang=ts"
export * from "./Production.vue?vue&type=script&lang=ts"

import "./Production.vue?vue&type=style&index=0&id=69d613fb&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69d613fb"]])

export default __exports__